import type { Document } from "@repo/types";
import { ExportDialog } from "../common/ExportDialog";
import { ExportDocumentForm } from "./ExportDocumentForm";

export interface ExportDocumentDialogProps {
  getDocuments: () => Document[];
  getPreselectedFields: () => string[];
}

export const ExportDocumentDialog = ({
  getDocuments,
  getPreselectedFields,
}: ExportDocumentDialogProps) => {
  return (
    <ExportDialog
      title="Export Documents"
      ExportForm={({ onCancel }) => (
        <ExportDocumentForm
          getDocuments={getDocuments}
          getPreselectedFields={getPreselectedFields}
          onCancel={onCancel}
        />
      )}
    />
  );
};
